<template>
  <div id="dlnkaap_liste_acteurs">

    <dlnkalert
        :message="message"
        :message_type="message_type"
        @close="close_message()"
    ></dlnkalert>

    <dlnkwait :wait_data="wait_data"></dlnkwait>
    <!-- Hero Section -->
    <div class="bg-primary">
    <div class="container space-2">
      <div class="w-md-80 w-lg-75 text-center text-white mx-md-auto">
        <h1 class="display-4 text-white">Ils oeuvrent sur le territoire</h1>
        <p class="lead">Les porteurs et leur projet qui ont participé aux appels à projet du département.</p>
        <a class="btn btn-light btn-lg mx-1" aria-disabled="true" href="/module/dlnkaap/map"
           role="button" style="font-size: 1.25rem">
          <i class="fa fa-map mr-2" aria-hidden="true"></i>Géolocaliser les projets
        </a>
        <a class="btn btn-light btn-lg mx-1" aria-disabled="true" href="/module/dlnkaap/candidature"
           role="button" style="font-size: 1.25rem">
          <span class="font-weight-bolder mr-2">€</span>Demander des aides
        </a>

      </div>
    </div>
    </div>
    <!-- End Hero Section -->


    <div class=" space-top-1 space-bottom-1">
      <i class="fa fa-arrow-left text-primary" aria-hidden="true"></i>
      <a href="#lien_de_la_page_précedemment_intégrer_par_tes_soins" title="retour">Retour</a>
    </div>
    <div class="col-12 mb-3 space-top-1">
          <!-- Tags (axes) -->
          <div class="d-sm-flex align-items-sm-center text-center text-sm-left">
            <span class="d-block mr-sm-3">Axes :</span>
            <div class="mx-sm-1">
              <input id="axe_tous" class="pill-checkbox d-none" type="checkbox">
              <label style="background: #0e91a029;" class="mb-0" for="axe_tous">Tous</label>
            </div>
            <div class="mx-sm-1">
              <input id="axe_sante_enfance" class="pill-checkbox d-none" type="checkbox" value="Santé et petite enfance" v-model="checked_axe">
              <label style="background: #0e91a029;" class="mb-0" for="axe_sante_enfance">Santé et petite enfance</label>
            </div>
            <div class="mx-sm-1">
              <input id="axe_famille_jeunesse" class="pill-checkbox d-none" type="checkbox" value="Famille / Jeunesse" v-model="checked_axe">
              <label class="mb-0" style="background: #0e91a029;" for="axe_famille_jeunesse">Famille / Jeunesse</label>
            </div>
            <div class="mx-sm-1">
              <input id="axe_insertion_sociale" class="pill-checkbox d-none" type="checkbox" value="Insertion et action sociale" v-model="checked_axe">
              <label class="mb-0" style="background: #0e91a029;" for="axe_insertion_sociale">Insertion et action sociale</label>
            </div>
            <div class="mx-sm-1">
              <input id="axe_logement_mixite" class="pill-checkbox d-none" type="checkbox" value="Logement et mixité sociale" v-model="checked_axe">
              <label class="mb-0" style="background: #0e91a029;" for="axe_logement_mixite">Logement et mixité sociale</label>
            </div>
            <div class="mx-sm-1">
              <input id="axe_autonomie" class="pill-checkbox d-none" type="checkbox" value="Autonomie (Handicap et Senior)" v-model="checked_axe">
              <label class="mb-0" style="background: #0e91a029;" for="axe_autonomie">Autonomie (Handicap et Senior)</label>
            </div>
          </div>
          <!-- End Tags -->
        </div>


    <!-- Blog Card Section -->
    <div class="container space-top-1">
     

          <div class="col-12 pl-0 multiselect mb-6" id="thematiques">
            <div class="selectBox" id="select_themes" v-on:mouseup="showCheckboxes($event)">
              <select class="custom-select">
                <option>Thématiques</option>
              </select>
              <div class="overSelect"></div>
            </div>
            <div class="checkboxes_multi">
              <div v-for="tag in tags" :key="tag.id">
                <label :for="'tag_' + tag.id">
                  <input type="checkbox"
                         :id="'tag_' + tag.id" v-model="checked_thematiques" :value="tag.id"/>
                  {{ tag.nom }}
                </label>
              </div>
            </div>
          </div>




      <div class="row mb-3">
        <div v-for="aap in aaps" :key="aap.id" class="col-sm-6 col-lg-4 mb-3 mb-sm-8">
          <!-- Blog Card -->
          <article class="card h-100">
            <div class="card-img-top position-relative">
              <img v-if="aap.projet_illustration" class="card-img-top" :src="aap.projet_illustration"
                   :alt="'Visuel du projet : ' + aap.projet_nom">
              <img v-else class="card-img-top" :src="pseudoRandomImage(aap.id)" :alt="'Visuel du projet : ' + aap.projet_nom">
              <figure class="ie-curved-y position-absolute right-0 bottom-0 left-0 mb-n1">
                <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 1920 100.1">
                  <path fill="#fff" d="M0,0c0,0,934.4,93.4,1920,0v100.1H0L0,0z"/>
                </svg>
              </figure>
              <div class="position-absolute" style="top: 10px; left: 10px">
                <span class="badge badge-primary" data-tooltip="tooltip" title="Recherche bénévoles" v-if="aap.benevoles"
                      style="z-index: 10; position: relative">
                      <i class="fa fa-users" aria-hidden="true"></i>
                </span>
                <span class="badge badge-primary" data-tooltip="tooltip" title="Besoins matériel" v-if="aap.besoins_materiels"
                      style="z-index: 10; position: relative">
                      <i class="fa fa-wrench" aria-hidden="true"></i>
                </span>
                <span class="badge badge-primary" data-tooltip="tooltip" title="Recherche locaux" v-if="aap.besoins_locaux"
                      style="z-index: 10; position: relative">
                      <i class="fa fa-building" aria-hidden="true"></i>
                </span>
              </div>
              <div class="position-absolute" style="top: 10px; right: 10px">
                <span class="badge badge-secondary">
                      <i class="fa fa-eye mr-1" aria-hidden="true"></i>{{ aap.views }}
                </span>
              </div>
            </div>

            <div class="card-body d-flex flex-column">
              <h3><a class="text-inherit stretched-link"
                     :href="'/module/dlnkaap/page_vitrine?aap_id=' + aap.id">{{ aap.projet_nom }}</a></h3>
              <p>{{ aap.activite_principale|truncate(300) }}</p>

              <div class="row d-flex align-items-center justify-content-between mt-auto">
                <div class="ml-3">
                  <p class="font-weight-bold mb-0">{{ aap.nom }}</p>
                </div>
                <div class="px-1">
                  <p class="text-muted mb-0"> {{ aap.creation_short }} </p>
                </div>
              </div>
            </div>
<!--  --------TODO : A AJOUTER PLUS TARD ---------     -->
<!--            <div class="card-footer py-3 border-top-2">-->
<!--              <div class="row d-flex align-items-center justify-content-between">-->
<!--                <div class="stretched-button">-->
<!--                  <a class="mx-1" href="#" data-tooltip="tooltip" title="Espace communautaire">-->
<!--                    <img class="avatar avatar-xs rounded" src="/modules/dlnkaap/img/icones/contact_icon.png" alt="Image Description">-->
<!--                  </a>-->
<!--                  <a class="mx-1" href="#" data-tooltip="tooltip" title="Activités">-->
<!--                    <img class="avatar avatar-xs rounded" src="/modules/dlnkaap/img/icones/calendar.png" alt="Image Description">-->
<!--                  </a>-->
<!--                </div>-->
<!--                <div class="stretched-button">-->
<!--                  <a class="mx-1" href="#" data-tooltip="tooltip" title="Voir le profil">-->
<!--                    <img class="avatar avatar-xs" src="/modules/dlnkaap/img/icones/profil.png" alt="Image Description">-->
<!--                  </a>-->
<!--                  <a class="mx-1" href="#" data-tooltip="tooltip" title="Envoyer un message">-->
<!--                    <img class="avatar avatar-xs rounded" src="/modules/dlnkaap/img/icones/chat.svg" alt="Image Description">-->
<!--                  </a>-->
<!--                </div>-->
<!--              </div>-->
<!--            </div>-->
          </article>
          <!-- End Blog Card -->
        </div>
      </div>



      <div class="row">
        <div class="col-12">
          <!-- Pagination -->
          <div class="mt-2">
            <dlnkpagination
                :page="page"
                :page_count="page_count"
                :from="from"
                :to="to"
                :show_count="true"
                :items_count="aaps_count"
                @next_page="next_page()"
                @prev_page="prev_page()"
                @set_page="set_page($event)">
            </dlnkpagination>
          </div>
          <!-- End Pagination -->
        </div>
      </div>


    </div>
    <!-- End Blog Card Section -->
  </div>
</template>

<script>
export default {
  props: {
    choose_theme: String,
  },
  data: function () {
    return {
      message: "",
      message_type: "",

      customer: Object,
      aaps: Array,
      tags: Array,

      wait_data: true,

      page: 1,
      page_count: Number,
      from: 0,
      to: 0,
      status_filter: [2,3,4,5,9],
      show_deleted: false,
      query: "",

      checked_thematiques: [],
      checked_participation: [],
      checked_axe: [],
      checked_besoins: [],
      expanded: false,
      currentSelect: "",

      // Filtre et recherche
      start_date: Date,
    }
  },
  mounted() {
    this.start_date = 'all'
    this.get_data()
  },

  filters: {
    truncate: function (data, num) {
      const reqdString =
          data.split("").slice(0, num).join("");
      return reqdString;
    }
  },

  created: function () {
    window.addEventListener('mousedown', this.mouseDownEvent);
  },
  destroyed: function () {
    window.removeEventListener('mousedown', this.mouseDownEvent);
  },

  computed: {},

  watch: {
    query: function (new_val, old_val) {
      if (new_val.length > 2) {
        this.get_data()
      }
    },

    checked_thematiques: function (new_val, old_val) {
      this.get_data()
    },

    checked_axe: function (new_val, old_val) {
      this.get_data()
    },

    page: function (new_val, old_val) {

      if (new_val < 1) {
        this.page = 1
      }

      if (new_val > this.page_count) {
        this.page = this.page_count
      }

      this.get_data()
    },

  },

  methods: {

    set_page: function (page) {
      page = parseInt(page)
      this.page = page
    },

    next_page: function () {
      this.page++
    },

    prev_page: function () {
      this.page--
    },

    close_message: function () {
      this.message = null;
    },

    pseudoRandomImage: function (aap_id) {
      let random = 1 + (aap_id % 25);
      return "/themes/template/img/group/photo_groupe/" + random.toString() + ".jpg";
    },

    showCheckboxes: function (event) {
      var checkboxes = event.target.parentElement.nextElementSibling;
      if (!this.expanded) {
        checkboxes.style.display = "block";
        this.expanded = true;
        this.currentSelect = event.target.parentElement.id;
      } else {
        checkboxes.style.display = "none";
        this.expanded = false;
      }
    },

    mouseDownEvent: function (event) {
      if (this.expanded) {
        var multiSelect = document.getElementById(this.currentSelect).nextElementSibling;
        if (!multiSelect.contains(event.target)) {
          //On a cliqué en dehors du select
          multiSelect.style.display = "none";
          this.expanded = false;
        }
      }
    },

    set_axe: function (event) {

      if (event.target.id !== "axe_tous") {
        const q = event.target.dataset.axe
        this.checked_axe = q;
      } else
        this.checked_axe = "";

      this.get_data()
    },

    get_data: function () {
      this.wait_data = true
      this.get_aaps()
      this.get_tags()
    },

    get_tags: async function () {
      let _this = this
      let [secure_key, customer_id, api_url, customer] = await get_token_2()
      api_url += "aap_tags.json"
      api_url += '?secure_key=' + secure_key
      api_url += '&customer_id=' + customer_id

      axios.get(api_url)
          .then(function (response) {
            _this.tags = response.data
          })
          .catch(function (error) {
            console.log(error)
          })
          .then(function () {
                // always executed
              }
          );
    },

    get_aaps: async function () {
      const _this = this;
      let [secure_key, customer_id, api_url, customer] = await get_token_2()
      api_url += "aaps.json"
      api_url += '?secure_key=' + secure_key
      api_url += '&customer_id=' + customer_id

      api_url += '&page=' + _this.page
      api_url += '&status=' + _this.status_filter
      api_url += '&public=true'
      api_url += '&tags=' + _this.checked_thematiques
      api_url += '&axe=' + _this.checked_axe
      if (_this.query.length > 2) {
        api_url += '&search=' + _this.query
      }

      _this.customer = customer

      axios.get(api_url)
          .then(function (response) {
            _this.aaps = response.data.aaps
            _this.page = response.data.meta.page
            _this.page_count = response.data.meta.pages
            _this.aaps_count = response.data.meta.count
            _this.from = response.data.meta.from
            _this.to = response.data.meta.to
            _this.wait_data = false
          })
          .catch(function (error) {
            console.log(error)
          })
          .then(function () {
                // always executed
              }
          );
    },

    reset_filter: async function () {
      this.checked_thematiques = [];
      this.checked_participation = [];
      this.checked_axe = [];
      this.get_aaps()
    },
  }
}
</script>
